import { Box, Button, IconButton } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { deleteLessonRequest } from "../../../modules/admin-modules/lessons/Actions";
import { openCreateLsson } from "../../../modules/admin-modules/models/Actions";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(91, 13, 22, 0.08)", color: C.secondary },
};

const LessonsTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const lessons = useSelector((state) => state.lessons.lessons);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.lessons.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(lessons) ? lessons : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter(
      (l) =>
        l?.title?.toLowerCase().includes(q) ||
        l?.grade?.name?.toLowerCase().includes(q) ||
        l?.chapter?.name?.toLowerCase().includes(q)
    );
  }, [lessons, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((l) => l.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    title: data?.title,
    chapter_id: data?.chapter?.id,
    chapter_name: data?.chapter?.name,
    grade_name: data?.grade?.name,
    publish: (
      <Button
        bg={C.primary}
        color="white"
        size="sm"
        borderRadius="full"
        fontWeight="800"
        _hover={{ bg: C.secondary }}
        onClick={(e) => e.stopPropagation()}
      >
        Publish
      </Button>
    ),
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit lesson"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openCreateLsson());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete lesson"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteLessonRequest(data?.id));
        }}
      />
    ),
  }));

  const columns = [
    { Header: "Title", accessor: "title" },
    { Header: "Grade", accessor: "grade_name" },
    { Header: "Chapter", accessor: "chapter_name" },
    { Header: "Publish", accessor: "publish" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="var(--surface-raised)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "var(--surface-muted)", color: "var(--text-primary)" }}
        />
      </Box>
    </Box>
  );
};

export default LessonsTable;
